<template>
<div>

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card" v-if="!loading">
<div class="grid">

<div class="col-12">
<div class="content_card_content evaluation_wrap">
<TabNavigation :tabs="tabs"></TabNavigation>
<router-view v-slot="{ Component }" :key="$route.fullPath">
    <transition name="routeslide" mode="out-in">
      <component :is="Component" />
    </transition>
</router-view>

</div>
</div>

</div>
</div>

<template  v-if="!loading && !is_supplier && !is_brand">
  <template v-if="show_finish_button">
    <AuditQuizStatusChanger  ></AuditQuizStatusChanger>
  </template>
  
</template>


<AuditNullReasonModal v-if="!loading"></AuditNullReasonModal>
<AuditEvidenceModal  v-if="!loading"></AuditEvidenceModal>
<AuditQuizFinishModal  v-if="!loading"></AuditQuizFinishModal>

</div>
</template>

<script>
export default {

  name: 'Audit',

  data () {
    return {
    	loading:true,
    	data:null,
    	tabs: [
          {
              title: 'geri_don',
              icon: 'home',
              route: 'cover',
          },
          {
              title: 'kapak',
              icon: 'id-card',
              route: 'cover',
          },
          {
              title: 'firma_belgeleri',
              icon: 'file-o',
              route: 'documents',
          },
          {
              title: 'sorular',
              icon: 'list',
              route: 'questionlist',
          },         
          {
              title: 'aksiyon_plani',
              icon: 'align-left',
              route: 'action_plan',
          }, 
          /*      
          {
              title: 'karne',
              icon: 'bookmark',
              route: 'report',
          },
          */
      ],
    }
  },
  computed:{
    userroles()
    {
       let user = this.$store.state.auth.user
      let userroles = user.userroles.map((element)=>{return element.name})
      return userroles
    },
    is_supplier()
    {     
      if(this.userroles.includes("supplier"))
      {
        return true
      }
      return false
    },
    is_brand()
    {     
      if(this.userroles.includes("brand"))
      {
        return true
      }
      return false
    },

    is_admin()
    {     
      if(this.userroles.includes("admin"))
      {
        return true
      }
      return false
    },
    show_finish_button()
    {
      if(this.data.audit.status=="finished" || this.data.audit.status=="under_review")
      {
        if(this.userroles.includes("admin") || this.userroles.includes("technical_auditor") )
        {
          return true
        }
        else
        {
          if(this.userroles.includes("auditor") && this.data.audit.status=="under_review")
          {
            return true
          }
          else
          {
            return false
          }
          
        }
      }
      else
      {
        return true
      }
    }
  },
  mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
  	{
  		this.loading = true
  		this.data = await this.generalApiGetWithoutLoader("auditor_audits/get_audit_data/"+this.$route.params.audit_uuid) 
      
      if(this.data.audit.status=="finished" || this.data.audit.status=="under_review")
      {
        this.$store.dispatch('evaluation/setMode',"admin_viewing") 
      }
      else
      {
        await this.$store.dispatch('evaluation/setMode',"admin_submitting") 
      }
      
      
      console.log(this.data)
      this.tabs[0].route = "AuditorAuditSummary"
      this.tabs[0].param = this.data.audit.id
      
  		await this.$store.dispatch('audit/setAudit',this.data.audit) 
      await this.$store.dispatch('evaluation/setEvaluation',this.data.audit.flowsupplier) 
  		await this.$store.dispatch('evaluation/setNullreasons',this.data.nullreasons) 
      await this.$store.dispatch('evaluation/setCustomattributes',this.data.customattributes) 
      await this.$store.dispatch('evaluation/setNonconformityTypes',this.data.nonconformity_types)
  		for(let tab of this.tabs)
        {
          if(tab.title!=="geri_don")
          {
            tab.route =  "/"+this.$store.state.auth.user.uuid+"/audit/"+this.$route.params.audit_uuid+"/"+tab.route
          }
          if(tab.title=="geri_don" && this.is_supplier)
          {
            tab.title="listeye_geri_don"
          }
          
        }

      if(this.is_supplier)
      {
        if(this.$store.state.evaluation.evaluation.status=="under_review" || this.$store.state.evaluation.evaluation.status=="started")
        {
          let projectsupplier = await this.silentApiGet("audit/get_project_supplier_id/"+this.$store.state.evaluation.evaluation.uuid)
          await this.$router.push({ name: 'SupplierBrandFlowSummary',params:{supplier_uuid:projectsupplier.supplier.uuid,project_id:projectsupplier.uuid,flow_id:this.$store.state.evaluation.evaluation.uuid} })
        }
      }
        
        //await this.getAndParseAuditData()

  		console.log(this.data)
  		this.loading = false
  	}
  }
}
</script>

<style lang="css" scoped>
</style>